import { jsx as _jsx } from "react/jsx-runtime";
import { Exclamation } from "@air/next-icons";
import { animated, config, useSpring } from "@react-spring/web";
import { memo } from "react";
export const FileStatusIconStopped = /*#__PURE__*/ memo(()=>{
    const [props] = useSpring(()=>({
            from: {
                scale: 0
            },
            to: {
                scale: 1
            },
            config: config.wobbly
        }), []);
    return /*#__PURE__*/ _jsx("div", {
        "aria-hidden": true,
        className: "mr-3 flex size-10 items-center justify-center rounded-full bg-yellow-3",
        children: /*#__PURE__*/ _jsx(animated.div, {
            className: "flex items-center justify-center",
            style: props,
            children: /*#__PURE__*/ _jsx(Exclamation, {
                className: "size-6 fill-yellow-9"
            })
        })
    });
});
FileStatusIconStopped.displayName = "FileStatusIconStopped";
